import { createFileRoute, redirect } from "@tanstack/react-router";
import { CALL_TYPE } from "~/constants/call";
import { VideoInCallTemplate } from "~/features/call/video/VideoInCallTemplate";
import { useCallStore } from "~/stores/useCallStore";

export const Route = createFileRoute("/_authenticated/call/video/")({
  staticData: { hideBottomNav: true },
  beforeLoad: () => {
    const { phase, callType } = useCallStore.getState();
    if (phase.type !== "inCall" && phase.type !== "ended") {
      throw redirect({ to: "/discover" });
    }
    if (callType === CALL_TYPE.VOICE) {
      throw redirect({ to: "/call/audio" });
    }
  },
  component: VideoInCallTemplate,
});
